(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kcb-tool-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const steps = Object.fromEntries([...root.querySelectorAll('[data-step]')].map((el) => [el.dataset.step, el]));
    const products = [...root.querySelectorAll('[data-product]')];
    const match = root.querySelector('[data-match]');
    const alternate = root.querySelector('[data-alternate]');
    const alternateWrap = root.querySelector('[data-alternate-wrap]');
    const state = { goal: '', need: '' };
    const show = (step) => {
      Object.entries(steps).forEach(([name, el]) => { el.hidden = name !== step; });
      steps[step].querySelector('h3')?.setAttribute('tabindex', '-1');
      steps[step].querySelector('h3')?.focus({ preventScroll: true });
    };
    const choose = () => {
      const ranked = products.map((el, index) => ({
        el, index,
        score: (el.dataset.goal === state.goal ? 10 : 0) + (el.dataset.need === state.need ? 3 : 0)
      })).sort((a, b) => b.score - a.score || a.index - b.index);
      if (!ranked.length) return;
      match.replaceChildren(ranked[0].el.cloneNode(true));
      const second = ranked.find((candidate) => candidate.el.dataset.goal === state.goal && candidate.el !== ranked[0].el);
      alternateWrap.hidden = !second;
      alternate.replaceChildren(...(second ? [second.el.cloneNode(true)] : []));
      show('result');
    };
    root.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button || !root.contains(button)) return;
      if (button.dataset.choice === 'goal') { state.goal = button.dataset.value; show('need'); }
      if (button.dataset.choice === 'need') { state.need = button.dataset.value; choose(); }
      if (button.hasAttribute('data-back')) show('goal');
      if (button.hasAttribute('data-reset')) { state.goal = ''; state.need = ''; show('goal'); }
    });
  };
  const init = () => document.querySelectorAll('[data-kcb-finder]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
